import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'
import { mapSearchDtoList } from '../../../mapping/trainees'

const dataApi = DataApi.getInstance()

export default function useSearchTrainees(search: string) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.searchTrainees, search], async () => {
    const { data } = await dataApi.searchTrainees(search)
    return mapSearchDtoList(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
